export const keyCodes = {
  ENTER: 13,
};



// WEBPACK FOOTER //
// ./app/features/shared/constants/keyCodes.js